import JourneyDigest from './JourneyDigest';

export default JourneyDigest;
